import Pqp from "../../../3x1010/Pqp.js";
import * as Solr from "../../../3x1010/Solr.js";
import DialogAddTerm from "../../../components/common/DialogAddTerm.component.js";
import NodeBoolean from "./NodeBoolean.js";
import NodeTerm from "./NodeTerm.js";

export default class QueryBuilder {
  constructor(type, target, collectionName, query = null, callback = null) {
    this.type = type;
    this.collectionName = collectionName;
    this.target = target;
    this.schema = new Solr.Schema(this.collectionName);
    this.query = query;
    this.callback = callback;
    this.nodes = [];

    console.log(this.collectionName);
    console.log(this.schema);
  }

  init() {
    if (this.query == null) {
      this.query = new Solr.QueryNodeBoolean(this.schema.findFieldByPath("/"));
    }
    //
    console.log(this.query);
    this.update();
  }

  getQuery() {
    return this.query;
  }

  getCollection() {
    return this.collectionName;
  }

  dispose() {
    this.clearAll();
  }

  update() {
    if (this.target == null) return;
    // Ridisegna ricorsivamente il nodo query
    this.clearAll();
    this.buildNextNode(this.target, 0, this.query, null);
  }

  clearAll() {
    // Dispone tutti i nodi
    for (let i = 0; i < this.nodes.length; i++) {
      this.nodes[i].dispose();
    }
    this.nodes = [];
  }

  buildNextNode(target, level, node, parent) {
    // A seconda del tipo di nodo, crea un nodo booleano o term
    if (node instanceof Solr.QueryNodeBoolean) {
      this.buildNodeBoolean(this.schema, target, level, node, parent);
    } else if (node instanceof Solr.QueryNodeTerm) {
      this.buildNodeTerm(target, level, node, parent);
    }
  }

  buildNodeBoolean(schema, target, level, node, parent) {
    let template = QueryBuilder.TEMPLATE_NODE_BOOLEAN_NERO;
    if (this.type === QueryBuilder.QUERY_BIANCA) {
      template = QueryBuilder.TEMPLATE_NODE_BOOLEAN_BIANCO;
    }
    // Crea un nodo booleano
    const nb = new NodeBoolean(this.type, schema, this.collectionName, template, target, level, node, parent, this.nodeEventsHandler.bind(this));
    nb.init();
    this.nodes.push(nb);

    if (node.Operator != Solr.QueryNodeBooleanType.EXISTS) {
      for (let clause of node.Clauses) {
        //console.log(nb.getInner());
        this.buildNextNode(nb.getInner(), level + 1, clause, nb);
      }
    }
  }

  nodeEventsHandler(e) {
    console.log(e);
    const node = e.data.node;
    let lUpdate = false;
    if (e.type === QueryBuilder.EVENT_ADD_BOOLEAN) {
      node.addSubNode(new Solr.QueryNodeBoolean(node.Field, false));
      lUpdate = true;
      console.log(e);
    } else if (e.type === QueryBuilder.EVENT_ADD_TERM) {
      this.showAddTermDialog(e.data);
    } else if (e.type === QueryBuilder.EVENT_REMOVE_BOOLEAN) {
      this.query.removeSubNodeById(node.id, true);
      lUpdate = true;
    } else if (e.type === QueryBuilder.EVENT_REMOVE_TERM) {
      this.query.removeSubNodeById(node.id, true);
      lUpdate = true;
    } else if (e.type === QueryBuilder.EVENT_CHANGE_COLLECTION) {
      this.dispatch(QueryBuilder.EVENT_CHANGE_COLLECTION, e.data);
    } else if (e.type === QueryBuilder.EVENT_CHANGE_OPERATOR) {
      lUpdate = true;
    }

    if (lUpdate) {
      this.printQuery();
      this.update();
    }
  }

  buildNodeTerm(target, level, node, parent) {
    // Crea un nodo term
    let template = QueryBuilder.TEMPLATE_NODE_TERM_NERO;
    if (this.type === QueryBuilder.QUERY_BIANCA) {
      template = QueryBuilder.TEMPLATE_NODE_TERM_BIANCO;
    }
    const nt = new NodeTerm(this.type, template, target, level, node, parent, this.nodeEventsHandler.bind(this));
    nt.init();
    this.nodes.push(nt);
  }

  showAddTermDialog(nodeBoolean) {
    const node = nodeBoolean.node;
    const level = nodeBoolean.level + 1;
    const fields = this.schema.getContextFields(node.Field._path, Solr.FieldFlags.FLAG_QUERY, level < QueryBuilder.MAX_NESTED_QUERIES, level < QueryBuilder.MAX_NESTED_QUERIES, true, true);
    // Prepara la struttura per la virtual select
    const flds = [];
    console.log(fields.length);
    console.log(fields);
    for (let x = 0; x < fields.length; x++) {
      let lbl = fields[x].Label;
      if (fields[x].Relation) {
        lbl += " (relazione)";
      } else if (fields[x].Type == Solr.FieldType.ComplexField) {
        lbl += " (entità)";
      } else if (fields[x].Lookup) {
        lbl += " (lemmario)";
      } else if (fields[x].Type == Solr.FieldType.StrField) {
        lbl += " (case sensitive)";
      }

      flds.push({
        _path: fields[x]._path,
        Label: lbl,
      });
    }

    this.dialog = new DialogAddTerm(".js-dialog-add-field", this.handleDialogEvents.bind(this, node));
    this.dialog.init(flds, node.Field._path);
    this.dialog.show();
  }

  handleDialogEvents(node, pathToAdd) {
    if (pathToAdd) {
      let subField = this.schema.findFieldByPath(pathToAdd);
      if (subField == null) return;
      // se è un campo complesso
      if (subField.Type == Solr.FieldType.ComplexField) {
        const toAdd = new Solr.QueryNodeBoolean(subField, true);
        node.addSubNode(toAdd);
      } else {
        const toAdd = new Solr.QueryNodeTerm(subField);
        //debugger;
        //PQPIMPORTANT;
        if (toAdd.Field.Type === Solr.FieldType.TextField && !toAdd.Field.Lookup) {
          //toAdd.Compare = Solr.QueryNodeCompareType.tALLTERMSw;
          toAdd.Compare = Solr.QueryNodeCompareType.tPHRASEw;
        } else if (toAdd.Field.Type === Solr.FieldType.TextField && toAdd.Field.Lookup) {
          toAdd.Compare = Solr.QueryNodeCompareType.sEQUALSw;
        } else if (toAdd.Field.Type === Solr.FieldType.StrField) {
          //toAdd.Compare = Solr.QueryNodeCompareType.sEQUALSw;
          toAdd.Compare = Solr.QueryNodeCompareType.sEQUALSw;
        }
        node.addSubNode(toAdd);
      }
      this.printQuery();
      this.update();
    }
  }

  printQuery() {
    console.log("---- Query ----");
    console.log(this.query);
    console.log("----------------");
  }

  dispatch(type, data) {
    if (this.callback) {
      this.callback({
        type,
        data,
      });
    }
  }
}

QueryBuilder.TEMPLATE_NODE_BOOLEAN_NERO = "#template-node-boolean-nero";
QueryBuilder.TEMPLATE_NODE_TERM_NERO = "#template-node-term-nero";

QueryBuilder.TEMPLATE_NODE_BOOLEAN_BIANCO = "#template-node-boolean-bianco";
QueryBuilder.TEMPLATE_NODE_TERM_BIANCO = "#template-node-term-bianco";

QueryBuilder.EVENT_ADD_BOOLEAN = "add-boolean";
QueryBuilder.EVENT_ADD_TERM = "add-term";
QueryBuilder.EVENT_REMOVE_BOOLEAN = "remove-boolean";
QueryBuilder.EVENT_REMOVE_TERM = "remove-term";
QueryBuilder.EVENT_CHANGE_COLLECTION = "change-collection";
QueryBuilder.EVENT_CHANGE_OPERATOR = "change-operator";

QueryBuilder.MAX_NESTED_QUERIES = 10;

QueryBuilder.SIMPLE_MODE = true;
QueryBuilder.QUERY_BIANCA = "bianca";
QueryBuilder.QUERY_NERA = "nera";
